export const POLL_CHECK_STATUS_INTERVAL = 1000;
export const POLL_RETRY_LIMIT = 10;
export const CONTEXT_CHANGE_DEBOUNCE = 100;
export const FLYOUT_RELOAD_EVENT_TYPE = 'cms:user-profile:reload';
